var link_viewer_wrapper_default = {
  "anchor": "i4o1n",
  "link": "YRyUa"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
